import { writable } from 'svelte/store';
import collect from 'collect.js';
// Constants
import { BetType } from '@/Constants/Bet.js';
import { Products } from '@/Constants/RaceProducts.js';
// Services
import { closestLadderPrice } from '@/Services/Helpers.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let _store;

	const { subscribe, set, update } = writable(collect());

	subscribe((current) => (_store = current));

	const methods = {
		/**
		 * ----------------- STORE METHODS -----------------
		 */

		applyPriceUpdates(data) {
			if (_store.firstWhere('selection_id', data.id.toString())) {
				let prices = collect(data.prices);
				update((items) => {
					return items.each((item) => {
						try {
							let newPrice = prices.firstWhere('id', item.id);
							if (newPrice) {
								item.price = parseInt(newPrice.price);
							}
						} catch (error) {
							console.error(error);
						}
						return item;
					});
				});
			}
		},

		// used to preview the potential prices based on fixed win
		calcDivisorPlacePrice(selectionId, divisor) {
			let winPrice = _store
				.where('selection_id', selectionId)
				.where('product.id', Products.Fixed)
				.firstWhere('bet_type.id', BetType.Win);

			if (winPrice && divisor) {
				// divisor calculation from Jim :)
				let price = ((winPrice.price / 100 - 1) / divisor + 1).toFixed(2);
				// we need to round to closest ladder price
				return closestLadderPrice(price).toFixed(2);
			}
			return 0;
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
